import React, { useState, useEffect, useMemo } from 'react'
import Link from 'next/link'
import Image from 'next/image'

import styled from '@emotion/styled'
import { getCookie } from 'cookies-next'
import { SwiperSlide } from 'swiper/react'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { getCommonSelectcity, getFrontMusteat } from 'api'
import Header from 'components/Header'
import Footer from 'components/Footer'
import Carousel from 'components/common/Carousel'
import { TAIL, HOST, BLUR } from 'constants/image'
import { switchWhitelabel } from 'lib'
import { DEFAULT_LANG } from 'constants/lang'

const SelectCity = ({
  s_commercial_area_id,
  s_city,
  initialCities,
  initialMusteat,
  channel,
}) => {
  const {
    t,
    i18n: { language: lang },
  } = useTranslation()

  const [cat1, setCat1] = useState(parseInt(s_city))
  const [cat2, setCat2] = useState(parseInt(s_commercial_area_id))

  const cities = useMemo(() => {
    let arr = []
    initialCities.filter((e) => e.cnt > 0 && arr.push(e))
    return arr
  }, [lang])

  const area = useMemo(() => {
    const areas = cities.find((e) => e.id === cat1).commercial_areas
    let arr = []

    areas.filter((e) => e.cnt > 0 && arr.push(e))
    return arr
  }, [cat1, lang])

  const [musteat, setMusteat] = useState(() => {
    let arr = []
    initialMusteat.filter((e) => e.must_eat_count && arr.push(e))
    return arr
  })
  const [didMount, setDidMount] = useState(false)

  useEffect(() => {
    if (!didMount) return
    callGetFrontMusteat(cat2)
    callGetCommonSelectcity()
  }, [lang])

  useEffect(() => {
    if (!didMount) return
    setCat2(cities.find((e) => e.id === cat1).commercial_areas[0].id)
    callGetFrontMusteat(
      cities.find((e) => e.id === cat1).commercial_areas[0].id
    )
  }, [cat1])

  useEffect(() => {
    if (!didMount) return
    callGetFrontMusteat(cat2)
  }, [cat2])

  useEffect(() => {
    setDidMount(true)
  }, [])

  // API 호출 함수
  const callGetCommonSelectcity = async () => {
    await getCommonSelectcity(lang, channel, 'client')
  }

  const callGetFrontMusteat = async (param) => {
    await getFrontMusteat({
      s_commercial_area_id: param,
      s_channel: channel,
      s_lang: lang,
    }).then((res) => {
      let arr = []
      res.must_eats.filter((e) => e.must_eat_count && arr.push(e))
      setMusteat(arr)
    })
  }

  return (
    <div>
      <Header title={t('city')} />

      <Container>
        <nav>
          <Carousel
            contents={cities.map((city) => (
              <SwiperSlide
                key={city.id}
                className="city"
                onClick={() => setCat1(city.id)}
              >
                <p
                  className={`${
                    cat1 === city.id ? 'city-clicked' : null
                  } ellipsis`}
                >
                  {city.translate_name2 ? city.translate_name2 : city.name2}
                </p>
              </SwiperSlide>
            ))}
            option={{
              slidesPerGroup: 3,
              spaceBetween: 0,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              initialSlide: cities.indexOf(cities.find((e) => e.id === cat1)),
            }}
          />
        </nav>
        <Section>
          <AreaList>
            <AreaUL>
              {area.map((item) => (
                <AreaLI
                  key={item.id}
                  onClick={() => setCat2(item.id)}
                  checked={cat2 === item.id}
                  className="ellipsis"
                  lang={lang}
                >
                  {item.translate_commercial_area_name}
                </AreaLI>
              ))}
            </AreaUL>
          </AreaList>
          <Musteat>
            <MusteatUL item={musteat.length}>
              {musteat.map(
                (item) =>
                  item.status === 'normal' && (
                    <MusteatLI key={item.id}>
                      <Link
                        href={`/must-eat?s_commercial_area_id=${cat2}&s_must_eat_id=${item.id}`}
                      >
                        <Image
                          src={
                            item.must_eat_file_path
                              ? `${HOST}${item.must_eat_file_path}${TAIL}`
                              : BLUR
                          }
                          alt=""
                          width={140}
                          height={120}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 5,
                          }}
                        />
                        <p>
                          {!item.translate_must_eat_name ||
                          item.translate_must_eat_name === ''
                            ? item.must_eat_name
                            : item.translate_must_eat_name}
                        </p>
                      </Link>
                    </MusteatLI>
                  )
              )}
            </MusteatUL>
          </Musteat>
        </Section>
      </Container>

      <Footer t={t} />
    </div>
  )
}

export default SelectCity

export const getServerSideProps = async (ctx) => {
  // const { req } = ctx
  // const subdomain = req ? req.headers.host.split('.')[0] : 'redtable'
  // const channel = switchChannel(subdomain)
  const channel = getCookie('channel', ctx)

  const initialLang =
    ctx.locale === 'zh-cn' ? 'zh-Hans' : getCookie('lang', ctx) || DEFAULT_LANG
  const { s_city, s_commercial_area_id } = ctx.query

  const cities = await getCommonSelectcity(
    {
      s_lang: initialLang,
      s_channel: channel,
    },
    'server'
  )

  const musteat = await getFrontMusteat(
    {
      s_commercial_area_id: switchWhitelabel(channel).s_commercial_area_id,
      s_channel: channel,
      s_lang: initialLang,
    },
    'server'
  )

  return {
    props: {
      s_city: s_city || switchWhitelabel(channel).cat2,
      s_commercial_area_id:
        s_commercial_area_id || switchWhitelabel(channel).s_commercial_area_id,
      initialCities: [...Object.values(cities)],
      initialMusteat: musteat.must_eats,
      ...(await serverSideTranslations(ctx.locale, 'common')),
    },
  }
}

const Container = styled.main`
  nav {
    position: sticky;
    top: 64px;
    z-index: 1;
  }

  .swiper-wrapper {
    background-color: #f8f8f8;
  }

  .city {
    width: 33%;
    height: 40px;
    line-height: 40px;
    background-color: #f8f8f8;
    position: sticky;
    top: 64px;
    text-align: center;
    cursor: pointer;
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    font-size: 16px;
    font-weight: 500;
  }

  .city-clicked {
    position: relative;
  }

  .city-clicked::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 5px;
    background-color: red;
  }
`

const Section = styled.section`
  display: flex;
`
const AreaList = styled.aside`
  position: fixed;
  background-color: #f1f1f1;
`

const AreaUL = styled.ul`
  height: calc(100vh - 64px - 40px - 72px);
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

const AreaLI = styled.li`
  width: 100px;
  height: 50px;
  font-size: 14px;
  border-bottom: 1px solid rgb(232, 232, 232);
  text-align: ${(props) =>
    props.lang === 'en' || props.lang === 'es' ? 'left' : 'center'};
  padding-left: ${(props) =>
    props.lang === 'en' || props.lang === 'es' ? '10px' : 0};
  line-height: 50px;
  cursor: pointer;
  background-color: ${(props) => props.checked && '#fff'};
  color: ${(props) => (props.checked ? '#ff4a52' : '#000')};
`

const Musteat = styled.div`
  padding-left: 100px;
  width: 100%;
`

const MusteatUL = styled.ul`
  display: grid;
  grid-gap: 10px;
  padding: 10px;
  grid-template-columns: 48% 48%;
  grid-template-rows: ${(props) =>
    props.item && `repeat(${Math.ceil(props.item / 2)}, 120px)}`};
`

const MusteatLI = styled.li`
  width: 100%;
  border-radius: 5px;
  position: relative;
  cursor: pointer;

  p {
    position: absolute;
    left: 10px;
    top: 10px;
    color: white;
    font-size: 16px;
    filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.5));
    word-break: keep-all;
  }
`
